import React from 'react';
import './index.css';
import { NavLink } from 'react-router-dom';
const Index = ({ Icon, close, name, ...props }) => {
    return (
        <NavLink
            onClick={() => {
                close();
            }}
            className="dashboard_nav_item"
            {...props}
        >
            <div className="dashboard_nav_item_div"> </div>
            <Icon className="dashboard_nav_item_icon" /> <p className="dashboard_nav_item_name">{name}</p>
        </NavLink>
    );
};

export default Index;
